import React, { ReactElement, HTMLAttributes } from 'react';
interface IIconCloseProps {
	className?: string;
	size?: string;
}
const IconClose = ({
    size = '',
    className = '',
    ...rest
}: IIconCloseProps & HTMLAttributes<any>): ReactElement => {
    return (
        <>
            {size === '24' ? (
                <svg
                    {...rest}
                    className={`'IconClose ${className}`}
                    width={size}
                    height={size}
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    aria-hidden
                >
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M12 10.9091L7.09091 6L6 7.09091L10.9091 12L6 16.9091L7.09091 18L12 13.0909L16.9091 18L18 16.9091L13.0909 12L18 7.09091L16.9091 6L12 10.9091Z'
                        fill='#767676'
                    />
                </svg>
            ) : (
                <svg
                    {...rest}
                    className={`'IconClose ${className}`}
                    width='32'
                    height='32'
                    viewBox='0 0 32 32'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
					aria-hidden
                >
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.78795 7.19088C8.39742 6.80036 7.76426 6.80036 7.37373 7.19088C6.98321 7.5814 6.98321 8.21457 7.37373 8.60509L14.5858 15.8172L7.05425 23.3487C6.66372 23.7393 6.66372 24.3724 7.05425 24.7629C7.44477 25.1535 8.07793 25.1535 8.46846 24.7629L16 17.2314L23.5316 24.7629C23.9221 25.1535 24.5553 25.1535 24.9458 24.7629C25.3363 24.3724 25.3363 23.7392 24.9458 23.3487L17.4142 15.8172L24.6263 8.6051C25.0168 8.21457 25.0168 7.58141 24.6263 7.19088C24.2358 6.80036 23.6026 6.80036 23.2121 7.19088L16 14.403L8.78795 7.19088Z'
                        fill='#767676'
                    />
                </svg>
            )}
        </>
    );
};

export default IconClose;
